import SubmitUserCode from 'gcs-common/components/SubmitUserCode/SubmitUserCode';
import UserCodeWebWrapper from '../UserCodeWebWrapper';

const SubmitUserCodeWeb = () => {
  return (
    <UserCodeWebWrapper>
      <SubmitUserCode />
    </UserCodeWebWrapper>
  );
};

export default SubmitUserCodeWeb;
